import { cuartosFriosSectors } from "@/mocks/serviceCuartosFriosData";

export default function CuartosFriosSectors() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Sectores
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Soluciones para diferentes industrias
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Nuestros cuartos fríos se adaptan a las necesidades de conservación y congelación de
            distintos sectores productivos.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {cuartosFriosSectors.map((sector, i) => (
            <div
              key={sector.name}
              className="reveal relative h-[180px] md:h-[220px] rounded-lg overflow-hidden group"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <img
                src={sector.image}
                alt={`Cuartos fríos para el sector ${sector.name.toLowerCase()}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/10 group-hover:from-foreground-950/90 transition-all duration-500" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-[#0087a4] shrink-0" />
                  <h3 className="font-heading font-bold text-background-50 text-sm md:text-base leading-tight">
                    {sector.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}